import Constants from 'expo-constants'

export const AUTH0_DOMAIN = Constants.manifest?.extra?.auth0Domain
export const AUTH0_CLIENT_ID = Constants.manifest?.extra?.auth0ClientId
export const AUTH0_AUDIENCE = Constants.manifest?.extra?.auth0Audience
